import axios from 'axios';
import store from '@/store';
import endpointVersion from '@/helpers/endpoint-version';
import i18n from '@/i18n';
import { buildAxiosParams } from './utils';
import { campaignsUrl } from './url';
export async function getCampaignsWithFilters(params) {
    const brand = store.getters.selectedBrand;
    const tokenV3 = store?.state?.auth?.tokenV3 ?? '';
    if (!brand?.id) {
        throw new Error(i18n.global.t('breadcrumb.email.campaigns.errors.brand-id-not-available'));
    }
    if (!tokenV3) {
        throw new Error(i18n.global.t('breadcrumb.email.campaigns.errors.auth-token-not-available'));
    }
    const emailCampaignsApi = campaignsUrl() || '';
    const url = emailCampaignsApi ? emailCampaignsApi : `${endpointVersion('v3')}/campaign/email/list`;
    const qsParams = {
        ...buildAxiosParams({
            page: params.page,
            limit: params.limit,
            orderBy: params.sort,
            filters: params.filters,
        }),
        ...(brand?.id && { brand_id: brand.id }),
    };
    const res = await axios.get(url, {
        params: qsParams,
        ...(tokenV3 && { headers: { Authorization: `Bearer ${tokenV3}` } }),
    });
    const raw = res.data;
    if (!raw || typeof raw !== 'object') {
        throw new Error(i18n.global.t('breadcrumb.email.campaigns.errors.payload-invalid'));
    }
    const data = raw;
    return { data };
}
